import { writable } from "svelte/store";

export const loginSceneVisibleStore = writable(false);
export const loginSceneVisibleIframeStore = writable(false);
